module.exports = "/static/assets/2e0c4790f8f9cf28e3c346b9cef0fcb6.svg";